export default {
  "notifications": {
    
  }
}